import { translate } from '@gig/magic-common';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var MaxContactAttributes;
(function(MaxContactAttributes2) {
  MaxContactAttributes2["CHANNEL_KEY"] = "data-channel-key";
  MaxContactAttributes2["PRIMARY_COLOUR"] = "data-primary-colour";
  MaxContactAttributes2["START_TEXT"] = "data-start-text";
  MaxContactAttributes2["THEME"] = "class";
  MaxContactAttributes2["ID"] = "id";
})(MaxContactAttributes || (MaxContactAttributes = {}));
class MaxContactService {
  constructor(config) {
    this.isLoaded = false;
    this.channelKey = "";
    this.sdkUrl = "";
    this.primaryColour = "";
    this.theme = "";
    this.widgetId = "";
    this.channelKey = config.channelKey;
    this.sdkUrl = config.sdkUrl;
    this.primaryColour = config.primaryColour;
    this.theme = config.theme;
    this.widgetId = config.widgetId;
  }
  loadMaxContact() {
    return __async(this, null, function* () {
      if (this.isLoaded || !this.channelKey || !this.sdkUrl) {
        return this.openChat();
      }
      this.appendTag();
      yield this.appendScript();
      setTimeout(() => {
        this.openChat();
      }, 500);
      this.isLoaded = true;
    });
  }
  appendTag() {
    const startText = translate("max-contact.start-text");
    const tag = document.createElement("div");
    tag.setAttribute(MaxContactAttributes.ID, this.widgetId);
    tag.setAttribute(MaxContactAttributes.THEME, this.theme);
    tag.setAttribute(MaxContactAttributes.CHANNEL_KEY, this.channelKey);
    tag.setAttribute(MaxContactAttributes.START_TEXT, startText);
    tag.setAttribute(MaxContactAttributes.PRIMARY_COLOUR, this.primaryColour);
    document.body.appendChild(tag);
  }
  appendScript() {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = this.sdkUrl;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.body.appendChild(script);
    });
  }
  openChat() {
    const button = document.getElementsByClassName("max-chat-header")[0];
    if (button) {
      button.click();
    }
  }
}

export { MaxContactAttributes, MaxContactService };
